<script setup>
import AppTopBar from "@/components/AppTopBar.vue";
import LoadingWrapper from "@/components/LoadingWrapper.vue";

import { ref, onMounted, provide } from 'vue';
import {useApiResource} from "@/composables/apiResource";
const loading = ref(true);
const { load: loadUser, data: user } = useApiResource()
    .endpoint("user")

import { useRoute } from 'vue-router';
const route = useRoute();
onMounted(async () => {
    try {
        await loadUser()
    } catch (e) {
        console.error(e);
    } finally {
        loading.value = false;
    }
})

const isAdmin = computed(() => {
    return user.value && user.value.roles?.indexOf('admin') !== -1;
});
const isReviewer = computed(() => {
    return user.value && user.value.roles?.indexOf('reviewer') !== -1;
});
provide('authenticatedUser', user)
provide('isAdmin', isAdmin)
provide('isReviewer', isReviewer)
</script>

<template>
    <loading-wrapper :loading="loading" class="min-h-screen">
        <app-top-bar />

        <div class="bg-white pt-24 pb-48 px-4 md:px-12 min-h-screen">
            <slot></slot>
        </div>
    </loading-wrapper>
</template>

